import React from "react";
import LoginHandler from "./components/Authentication/LoginHandler";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/components/styles/themeR2C.scss";
import "../src/components/styles/themeSN.scss";

const App: React.FC = () => {
  return <LoginHandler />;
};

export default App;
